(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !window.DesignMode) return;
  try {
    
  if( window.innerWidth < 768 ) {
    var filterEle = document.querySelector('.gf-filter-trigger'); 
    var waitForFilterEl = function(selector, maxtries=false,interval=100, callback) {
        const poller = setInterval(() => {
        const el = jQuery(selector)
        const retry = maxtries === false || maxtries-- > 0
        if (retry && el.length < 1) return // will try again
        clearInterval(poller)
        callback(el || null)
      }, interval);
    };
    waitForFilterEl(filterEle, 10, 100, function() {
      jQuery("section.products .content.header .d-flex").append( jQuery(".gf-filter-trigger") );
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 110;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if( this.header.querySelector('.navbar-toggler.collapsed') )  {
        this.header.classList.add('d-none', 'fixed-top');
        this.closeMenuDisclosure();
      };
    }

    reveal() {
      this.header.classList.add('d-block', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('d-block', 'fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
  var productObj = JSON.parse(document.getElementById('ProductJson').innerHTML);
  var metafieldObj = JSON.parse(document.getElementById('MetafieldJson').innerHTML);
  var variantObj = getVariant( document.querySelector('[name="id"]').value );

  function setVariant(variant) {
    variantObj = variant;
    
    jQuery('[variant-title]').html( variant.title );
    jQuery('[variant-select] option').attr("selected",false);
    jQuery('[variant-select] option[value="'+ variant.id +'"]').attr("selected",true);

    // update UI items
    updatePrice(); // Updates display price and sale display
    updateImages();
    updateCTA( variant.available ); // Display Buy CTA for Variant
    updateHistoryState(); // Adds Variant ID to URL for deeplinking
  };

  function updateShopifyPaymentsMonthlyPrice(newPrice) {
    const timeout = 3000;
    const interval = 100;
    const start = Date.now();
  
    function calculateMonthlyInstallment(purchaseAmount, apr = 15, months) {
      const monthlyRate = apr / 100 / 12;
      const n = months;
      const monthlyPayment = (monthlyRate * purchaseAmount) / (1 - Math.pow(1 + monthlyRate, -n));
      return monthlyPayment;
    }
  
    const check = setInterval(function () {
      const host = document.querySelector('shopify-payment-terms'); // replace with correct shadow host tag or selector
      if (host && host.shadowRoot) {
        const el = host.shadowRoot.getElementById('shopify-installments-content');
        if (el) {
          const span = el.querySelector('span');
          if (span) {
            const months = newPrice < 15000 ? 4 : 12;
            const monthly = calculateMonthlyInstallment(newPrice, 15, months);
            span.textContent = Shopify.formatMoney(Math.round(monthly));
            clearInterval(check);
          }
        }
      }
  
      if (Date.now() - start >= timeout) {
        clearInterval(check);
        console.warn('Could not find shopify-installments-content in shadow DOM within 3 seconds.');
      }
    }, interval);
  }

  function updatePrice() {
    var variantMetafields = getVariantMetafields();
    var productPrice = variantObj.price;
    var originalPrice = variantObj.compare_at_price;
  
    var productEl = document.querySelector('.product-header');
    // will use variant strike price percentage instead of theme settings' percentage by Bill Kim
    var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true' && variantMetafields.strike_price_percentage > 0;
    var strikeDiscount = variantMetafields.strike_price_percentage;
    // var hasStrikePrice = productEl?.dataset?.strikeEnabled === 'true';
    // var strikeDiscount = parseFloat(productEl?.dataset?.strikeValue || '0');
  
    // Apply strike price if valid
    if (hasStrikePrice && strikeDiscount > 0) {
      originalPrice = productPrice; // Save original before applying strike
      productPrice = Math.round(productPrice * ((100 - strikeDiscount) / 100));
    }
  
    // Update main price
    document.querySelector(".product-header [product-price]").innerHTML = Shopify.formatMoney(productPrice);
    updateShopifyPaymentsMonthlyPrice(productPrice);
  
    // If strike or compare_at_price is valid, show original price
    if (productPrice < originalPrice) {
      document.querySelector(".product-header [original-price]").innerHTML = Shopify.formatMoney(originalPrice);
      jQuery('.product-header [original-price], .badge-sale').removeClass('d-none');
    } else {
      jQuery('.product-header [original-price], .badge-sale').addClass('d-none');
    }
  }

  function updateCTA(is_available) {

    if( is_available == true ) {
      jQuery('.klaviyo-bis-trigger').hide();
      jQuery('#AddToCartButton').removeAttr("disabled");
      jQuery('#AddToCartButton span').html( lang_add_to_cart );
    } else {
      jQuery('.klaviyo-bis-trigger').show();
      jQuery('#AddToCartButton').attr("disabled", true);
      jQuery('#AddToCartButton span').html( lang_sold_out );
    };
  };

  function updateImages() {
    var variant_id = variantObj.id;
    var variant_image = variantObj.featured_image;
    var variant_carousel = jQuery("#variant-carousel-"+variant_id);
    var media_carousel = jQuery("#mip-carousel div.carousel");

    // If product has variants load MIP Variants
    if( variant_carousel.length > 0 ) {
      jQuery("#mip-carousel > div").replaceWith( "<div class='carousel'>" + variant_carousel.html() + "</div>" ); // Replace default image loaded with variant container
      initMip();
    } else if(media_carousel.length < 1) {
      var sizedSrcset = Shopify.resizeImage(variant_image.src, '500x'); //resize
      var sizedSrc = Shopify.resizeImage(variant_image.src, '800x'); //resize
      jQuery("#mip-carousel > div").replaceWith('<div><picture><source media="(max-width: 500px)" srcset="'+sizedSrcset+'"><img src="'+sizedSrc+'" width="800" height="800" class="img-fluid" alt="'+product.title+'"></picture></div>');
    } else {
      initMip();
      jQuery('#mip-carousel div.carousel.slick-initialized').slick('slickGoTo', variant_image.position-1 );
    };

    initMediaZoom();

  };

  function initMediaZoom() {
    var mediaZoomModalEl = document.getElementById('mediaZoom');
    var mediaZoomModal = bootstrap.Modal.getOrCreateInstance(mediaZoomModalEl);

    mediaZoomModalEl.addEventListener('hidden.bs.modal', event => {
       mediaZoomModalEl.querySelector('.modal-body').innerHTML = '';
    });

    var mediaItemsList = [].slice.call(document.querySelectorAll('#mip-carousel .img-fluid'));
    var mediaItems = mediaItemsList.map(function (mediaEle) {
      mediaEle.addEventListener('click', function(evt){

        var slideIndex = Array.from(evt.target.parentElement.parentElement.children).indexOf(evt.target.parentElement);

        var mediaClone = document.querySelector('.media #mip-carousel').cloneNode(true);
        mediaZoomModalEl.querySelector('.modal-body').appendChild( mediaClone );
        
        jQuery('.modal-body .carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: slideIndex,
          lazyLoad: 'ondemand',
          touchMove: true,
          arrows: true,
          dots: false
        });

        mediaZoomModal.show();
        
      });
    });
  };
  
  function initMip() {
    var carousel_element = jQuery('#mip-carousel div.carousel').not('.slick-initialized');

    // If carousel content exists
    if( carousel_element.length > 0 && window.innerWidth < 768 ) {
      carousel_element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchMove: true,
        arrows: false,
        dots: true
      });

    } // end If carousel content exists
  }

  function updateHistoryState() {
    var querystring = new URLSearchParams(window.location.search)
    querystring.set('variant', variantObj.id);
    /* querystring.set('selling_plan', (sellingPlan)?sellingPlan.selling_plan_id:''); */
    querystring = '?' + querystring.toString();
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + querystring;
    window.history.replaceState({path: newurl}, '', newurl);
  };

  function getVariant( variantId=false ) {
    var currentVariant = (variantObj)?variantObj:false;
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    if( currentVariant && currentVariant.id == variantId ) {
      variantObj = variantObj;
      return variantObj;
    } else {
      var variants = productObj.variants;
      var variant = variants.find(({ id }) => id === Number(variantId));
      variantObj = variant;
      return variant;
    };
  };

  function getVariantMetafields( variantId=false ) {
    if( !variantId ) { variantId = document.querySelector('form [name="id"]').value; }
    return metafieldObj.find(({ id }) => id === Number(variantId));
  };

  function changeSpecs(variantId) {
    var variantMetafields = getVariantMetafields(variantId);
    variantMetafields = variantMetafields.specifications[0];
    var ele = document.querySelector('.specifications');
    if( ele && variantMetafields!=null && typeof variantMetafields  === 'object' ) {
      Object.keys(variantMetafields).forEach(function(key,index, value) {
        if(key == 'product') { return; }
        var classTarget = (key.includes('packed'))?'.packed':'.assembled';
        var metaValue = variantMetafields[key];
        var targetEle = ele.querySelector('.'+key.replace('packed_','')+' '+classTarget);
        targetEle.innerHTML = '<span>'+metaValue[0].value+'</span><span>'+metaValue[0].unit+'</span>';
      });   
    };
  };
  
  /* JS loaded: hide dropdown and show option swap */
  document.querySelector('.variant-select').style.display = "none";
  var options_ele = document.querySelectorAll('.product-options');
  [].forEach.call(options_ele, function(ele) {
    ele.style.display = "block";
  });

  jQuery('.product-options :radio, .product-options select').on('change', function () {

    if( jQuery(this).is("input") ) {
      jQuery("#selected-option-"+jQuery(this).attr('name').toLowerCase().replace(/ /g,'-')).text( jQuery(this).val() );
    }

    /* loop through all available options and get currently selected value */
    
    var selected_options = [];
    productObj.options.forEach(async function(option) {
      if( document.querySelector('[data-option="'+option+'"] input') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] input:checked').value );
      } else if(document.querySelector('[data-option="'+option+'"] select') ) {
        selected_options.push( document.querySelector('[data-option="'+option+'"] select').value );
      }
    });

    /* find variant by selected value(s) */
    var selected_variant = productObj.variants.find(function(variant, index) {
      if(selected_options.length == 3 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] && variant.option3 == selected_options[2] ) {
        return true;
      } else if(selected_options.length == 2 && variant.option1 == selected_options[0] && variant.option2 == selected_options[1] ) {
        return true;
      } else if(selected_options.length == 1 && variant.option1 == selected_options[0]) {
        return true;
      } else {
		return false;
	  }
    });

	/* If variant does't exist, show as sold out w/o notify ability */
    if(!selected_variant) { 
		//alert("That combination isn't available. Choose another option.");
        updateCTA( false );
		jQuery('.klaviyo-bis-trigger').hide();
		return false;
	};

    setVariant( selected_variant );
    changeSpecs( selected_variant.id );
  });

  if (parseInt($(window).width()) < 992 ) {
    jQuery('#product_header').prependTo(".product-header > div > div.d-flex");
    jQuery('#product_header').addClass("content");
  };

  setVariant(variantObj);


  } catch(e) { console.error(e); }
})();
})();
